module.exports = __webpack_public_path__ + "img/W7019-tran.274badc4.jpg";